import { connect } from 'react-redux'

import { doCancel } from 'actions/merge'

import { selectTargetTicket } from 'selectors/merge'
import { selectCurrentTicket } from 'selectors/tickets'
import { selectCurrentTicketIsDelayed } from 'selectors/undoSend'

import View from './view'

const select = state => ({
  isDelayed: selectCurrentTicketIsDelayed(state),
  targetTicket: selectTargetTicket(state),
  ticket: selectCurrentTicket(state),
})

const perform = {
  doCancel,
}

export default connect(select, perform)(View)
